export const LOAD_VOLUME_DURATION = {
	DAY: 'Day',
	WEEK: 'Week',
	MONTH: 'Month',
	YEAR: 'Year',
};
